var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{staticClass:"multi-col-validation mt-1"},[(!_vm.loading)?_c('v-container',{attrs:{"grid-list-xs":""}},[_c('HotelsForm')],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }